import React from "react";

function HotelOnRequest() {
  return <div>HotelOnRequest</div>;
}

export default HotelOnRequest;
